export const DATA_TYPE_STREET = 'street';
export const DATA_TYPE_PARKING = 'parking';
export const DATA_TYPE_OIL = 'oil';
export const DATA_TYPE_NEWENERGY = 'newEnergy';
export const DATA_TYPE_WC = 'wc';


export const DATA_TYPE_HUMAN = {
    [DATA_TYPE_STREET]: "路边停车",
    [DATA_TYPE_PARKING]: "停车场",
    [DATA_TYPE_OIL]: "加油站",
    [DATA_TYPE_NEWENERGY]: "新能源",
    [DATA_TYPE_WC]: "建宁驿站",
};